import React from 'react';
import { LandingPageConfig } from 'src/generated/landing-page-config-schemas/v1/type';
import HowItWorksBase from 'src/components/HowItWorks';

type Props = Extract<
  LandingPageConfig['data']['slices'][number],
  { type: 'how-it-works' }
> & {
  backgroundColor: string;
};

const HowItWorks: React.FC<Props> = ({ title, backgroundColor }) => {
  return <HowItWorksBase title={title} backgroundColor={backgroundColor} />;
};

export default HowItWorks;
